import { OverridablePropertiesFieldState, OverridablePropertiesPermissions } from '@/common/constants';
import { UserModel } from '@/modules/user/stores/auth.types';
import { setDataDogUser } from '@/utils/config';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  organizationId: string;
  contactId: string;
  auth: boolean;
  inited: boolean;
  user: UserModel | null;
  overridablePropertiesPermissions: OverridablePropertiesPermissions | null;
  overridablePropertiesFieldState: OverridablePropertiesFieldState | null;
  observedOrganizationPath?: string;
  setAuth: (value: boolean) => void;
  setUser: (user: UserModel | null) => void;
  setOverridablePropertiesPermissions: (
    overridablePropertiesPermissions: OverridablePropertiesPermissions | null
  ) => void;
  setOverridablePropertiesFieldState: (
    overridablePropertiesFieldState: OverridablePropertiesFieldState | null
  ) => void;
  setOrganizationId: (organizationId?: string, contactId?: string) => void;
  setContactId: (organizationId?: string, contactId?: string) => void;
  setObservedOrganizationPath: (observedOrganizationPath?: string) => void;
}

export const useAuthStore = storeCreator<State>((set) => ({
  organizationId: '',
  contactId: '',
  auth: false,
  inited: false,
  user: null,
  observedOrganizationPath: undefined,
  overridablePropertiesPermissions: null,
  overridablePropertiesFieldState: null,
  setAuth: (value: boolean) =>
    set(() => ({
      auth: value,
      inited: true,
    })),
  setObservedOrganizationPath: (observedOrganizationPath?: string) =>
    set(() => ({
      observedOrganizationPath,
    })),
  setUser: (user: State['user']) =>
    set(() => {
      if (user && user.id) {
        setDataDogUser({
          id: user.id,
          person_id: user.id,
          contact_id: user.contactId || user.id,
        });
      }
      return {
        user,
      };
    }),
  setOverridablePropertiesPermissions: (
    overridablePropertiesPermissions: OverridablePropertiesPermissions | null
  ) =>
    set(() => ({
      overridablePropertiesPermissions,
    })),
  setOverridablePropertiesFieldState: (
    overridablePropertiesFieldState: OverridablePropertiesFieldState | null
  ) =>
    set(() => ({
      overridablePropertiesFieldState,
    })),
  setOrganizationId: (organizationId: string = '') =>
    set(() => ({
      organizationId,
    })),
  setContactId: (contactId: string = '') =>
    set(() => {
      // The JWT already carries the contact id, so RUM gets the user as soon as
      // the token is known instead of waiting for contact/permission queries.
      if (contactId) {
        setDataDogUser({
          id: contactId,
          person_id: contactId,
          contact_id: contactId,
        });
      }
      return {
        contactId,
      };
    }),
}));

export default useAuthStore;
